import service from '@/request';

export const getAreasData = () => {
  return service({
    url: 'experienceShop/findShopRegionInfo',
    method: 'post',
  });
};

export const getUserCurArea = (data) => {
  return service({
    url: 'uiExperienceShopApi/findUiUserPath',
    method: 'post',
    data
  });
};

export const getShopList = (data = {}) => {
  return service({
    url: 'uiExperienceShopApi/findUiShopList',
    method: 'post',
    data
  });
};

export const getShopListPage = (data = {}) => {
  return service({
    url: 'uiExperienceShopApi/findUiShopPage',
    method: 'post',
    data
  });
};


